import { formElement } from "../../forms/FormElement";
import HotWorkCategoryTwoOptionsFormState from "../../forms/Permits/EnergyHarbourPermit/HotWorkCategoryTwoOptionsFormState";

export const HOT_WORK_CATEGORY_TWO_OPTIONS_VERSION_2026_03 = 1;

type HotWorkCategoryTwoOptions = {
    version: number | undefined;
    screwDriverDrill: boolean;
    openEquipment: boolean;
    multimeter: boolean;
    megger: boolean;
    excavator: boolean;
    exCamera: boolean;
    GPS: boolean;
    totalStation: boolean;
    other: string;
    tigersaw: boolean;
    circularSaw: boolean;
    sparkFreeGrindingWheel: boolean;
    fiberWelding: boolean;
};

export default HotWorkCategoryTwoOptions;

export function HotWorkCategoryTwoOptions_toFormState(
    hotWorkCategoryTwoOptions: HotWorkCategoryTwoOptions
): HotWorkCategoryTwoOptionsFormState {
    return {
        screwDriverDrill: formElement(hotWorkCategoryTwoOptions.screwDriverDrill),
        openEquipment: formElement(hotWorkCategoryTwoOptions.openEquipment),
        multimeter: formElement(hotWorkCategoryTwoOptions.multimeter),
        megger: formElement(hotWorkCategoryTwoOptions.megger),
        excavator: formElement(hotWorkCategoryTwoOptions.excavator),
        exCamera: formElement(hotWorkCategoryTwoOptions.exCamera),
        GPS: formElement(hotWorkCategoryTwoOptions.GPS),
        totalStation: formElement(hotWorkCategoryTwoOptions.totalStation),
        other: formElement(hotWorkCategoryTwoOptions.other),
        circularSaw: formElement(hotWorkCategoryTwoOptions.circularSaw),
        tigersaw: formElement(hotWorkCategoryTwoOptions.tigersaw),
        fiberWelding: formElement(hotWorkCategoryTwoOptions.fiberWelding),
        sparkFreeGrindingWheel: formElement(hotWorkCategoryTwoOptions.sparkFreeGrindingWheel)
    };
}
